import React from 'react';
import { Grid } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { getIsHandledByMultivalueJson } from '../../../utils/multivalueJsonAttributes';

function RestaurantServicesIcons(services) {
  let categories: string[] = [];
  const { t } = useTranslation();
  services.services.forEach(service => {
    if (categories.includes(service.categoryCode)) {
      return;
    }
    categories.push(service.categoryCode);
  });
  return (
    services && (
      <div>
        {categories.map(category => (
          <Grid
            container
            spacing={0}
            style={{ marginTop: 10, marginBottom: 30, textAlign: 'left' }}
          >
            <Grid
              item
              style={{ fontWeight: 900, width: '100%', marginBottom: '1em' }}
            >
              {t(`restaurant.categoriesAndServices.${category}`)}
            </Grid>
            {services.services?.map((service, index) => {
              if (getIsHandledByMultivalueJson(service.code)) return null;

              let parent: any = null;
              if (service.parent) {
                parent = services.services.find(
                  item => item.code === service.parent,
                );
              }
              return (
                (!parent || parent?.value) &&
                service.categoryCode === category && (
                  <React.Fragment key={`${service.code}-${index}`}>
                    <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                      {service.type === 'toggle' &&
                        (service.value ? <Check /> : <Close />)}
                    </Grid>
                    <Grid
                      item
                      xl={10}
                      lg={10}
                      md={10}
                      sm={10}
                      xs={10}
                      style={{ color: 'grey' }}
                    >
                      {t(
                        `restaurant.attributes_and_services.${service.code}`,
                        service.name,
                      )}:
                      {service.type === 'enum' && !service.multivalueJson && service.value && `: ${service.value}`}
                      {service.type === 'enum' && service.multivalueJson && renderMultivalueJson(service)}
                    </Grid>
                  </React.Fragment>
                )
              );
            })}
          </Grid>
        ))}
      </div>
    )
  );
}

export default RestaurantServicesIcons;

function renderMultivalueJson(service) {
  const { multivalueJson } = service;
  if (!multivalueJson) return null;
  const data = JSON.parse(multivalueJson);
  return (
    <Grid container direction="column">
      {data.filter((p) => !!Number(p[1])).map(([key, value]) => (<Grid item>{`${key}: ${value}`}</Grid>))}
    </Grid>
  );
}
